<template>
  <div class="home">
    <section class="hero">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="hero-card overlaped-squares-background">
              <h1>
                Encontre o
                <b>Curso de Formação</b> mais indicado para si
              </h1>
              <div class="form-group form-group-course">
                <select
                  class="form-control custom-select"
                  v-if="courseList !== []"
                  v-model="selectedCourse"
                  @change="redirectToCourse"
                >
                  <option value="">Selecione um curso</option>
                  <option v-for="course in courseList" :key="course.code" :value="course.humanFriendlyName">{{ course.humanFriendlyName }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="brands">
        <div class="container">
            <div class="row">
                <div class="col-6 col-md-4 mx-auto">
                    <img src="https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/brands/regus.svg">
                </div>
                <div class="col-6 col-md-4 mx-auto">
                    <img src="https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/brands/rtp.svg">
                </div>
                <div class="col-6 col-md-4 mx-auto">
                    <img src="https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/brands/novaday.png">
                </div>
                <div class="col-6 col-md-4 mx-auto">
                    <img src="https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/brands/lizgarden.png">
                </div>
                <div class="col-6 col-md-4 mx-auto">
                    <img src="https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/brands/mge.png">
                </div>
                <div class="col-6 col-md-4 mx-auto">
                    <img src="https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/brands/mcoutinho.png">
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
    data() {
        return {
            courseList: [],
            selectedCourse: '',
        };
    },
    created() {
        axios
            .get('https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/course-list.json')
            .then((response) => {
                this.courseList = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        redirectToCourse() {
            this.$router.push({ path: `/${slugify(this.selectedCourse).toLowerCase()}`, query: this.$route.query });
        },
    },
    name: 'Home',
};
</script>

<style lang="scss">
@import '@/assets/scss/home.scss';

</style>
